import { OccConfig } from '@spartacus/core';

export const accountSelectionOccConfig: OccConfig = {
  backend: {
    occ: {
      endpoints: {
        addressSelection: '/users/current/units/available-ship-to?accountNumber=${accountID}',
        accountSelection: '/users/current/units/customer-accounts',
        current: '/orgUsers/current',
      } as any,
    },
  },
};
